import { OwnershipEntities, OwnershipConditionKeys, OwnershipConditionTypes } from "./types";
import { formatNumber } from "@/uiCore";

// Helper function to format currency amount
export const formatCurrencyAmount = (amount: number, currency?: string): string => {
  const safeCurrency = currency && /^[A-Z]{3}$/.test(currency) ? currency : "USD";
  return formatNumber(amount, {
    currency: safeCurrency,
    notation: "standard",
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  });
};

// Helper function to get available condition keys for an entity type
export const getConditionKeysForEntity = (
  entityType: OwnershipEntities
): OwnershipConditionKeys[] => {
  switch (entityType) {
    case OwnershipEntities.WAREHOUSE:
      return [OwnershipConditionKeys.WAREHOUSE_NAME, OwnershipConditionKeys.WAREHOUSE_TAG];
    case OwnershipEntities.QUERY:
      return [
        OwnershipConditionKeys.QUERY_WAREHOUSE_NAME,
        OwnershipConditionKeys.QUERY_USER,
        OwnershipConditionKeys.QUERY_ROLE,
        OwnershipConditionKeys.QUERY_TAG,
      ];
    case OwnershipEntities.TABLE:
      return [OwnershipConditionKeys.TABLE_NAME];
    case OwnershipEntities.DATABASE:
      return [OwnershipConditionKeys.DATABASE_NAME];
    case OwnershipEntities.SCHEMA:
      return [OwnershipConditionKeys.SCHEMA_NAME];
    default:
      return [];
  }
};

// Helper function to get available condition types for a condition key
export const getConditionTypesForKey = (
  conditionKey: OwnershipConditionKeys
): OwnershipConditionTypes[] => {
  const tagKeys = [OwnershipConditionKeys.WAREHOUSE_TAG, OwnershipConditionKeys.QUERY_TAG];
  if (tagKeys.includes(conditionKey)) {
    return [OwnershipConditionTypes.EQUALS];
  }
  return [
    OwnershipConditionTypes.EQUALS,
    OwnershipConditionTypes.STARTS_WITH,
    OwnershipConditionTypes.CONTAINS,
    OwnershipConditionTypes.IN,
  ];
};

